import { title } from "process";

export default {
  auth: {
    login: 'Connexion',
    logout: 'Se déconnecter',
    no_match: 'Vos mots de passe ne correspondent pas',
    forgot: {
      title: 'Mot de passe oublié',
      instruction: "Entrez votre adresse e-mail pour recevoir un e-mail expliquant comment créer un nouveau mot de passe.",
      confirmation: 'Un nouveau mot de passe a été envoyé à votre e-mail.',
      submit: 'Récupérer',
    },
    reset: {
      title: 'Réinitialiser le mot de passe',
      description: 'Créez un nouveau mot de passe.',
      submit: 'Réinitialiser',
      submitted: 'Votre mot de passe a été mis à jour.'
    },
    submitted: {
      success: 'Terminé !',
      sent: 'Nous vous avons envoyé un e-mail à {email}.',
      again: 'Reconnectez-vous',
    },
    required: {
      email: 'Email invalide',
      password: 'Le mot de passe est requis',
      default: 'Requis',
      name: 'Nom invalide',
      url: 'URL invalide',
      number: 'Seuls les chiffres sont autorisés',
      passwordRules: {
        lowercase: 'Au moins une lettre minuscule requise',
        uppercase: 'Au moins une lettre majuscule requise',
        length: 'Minimum 8 caractères',
        number: 'Au moins un chiffre requis',
        special: 'Au moins un caractère spécial requis',
        match: 'Les mots de passe doivent correspondre',
      },
    },
  },
  actions: {
    back: 'Retour',
    next: 'Suivant',
    add: 'Ajouter',
    edit: 'Modifier',
    save: 'Enregistrer',
    create: 'Créer',
    close: 'Fermer',
    esc: 'esc',
  },
  labels: {
    description: 'Description',
  },
  event: {
    title: "Enregistrement d'heures",
    dialog: {
      create: 'Créer',
      edit: 'Modifier',
      remove: 'Supprimer',
    },
  },
  user: {
    add: 'ajouter {item}',
    title: 'Utilisateur ',
    statuses: {
      active: 'Actif',
      blacklist: 'Liste noire',
      discontinued: 'Arrêté',
      openInvoice: 'Facture ouverte',
    },
  },
  mfa: {
    title: 'Jeton MFA',
  },
  roles: {
    user: 'Utilisateur | Utilisateurs',
    title: 'Utilisateur'
  },
  request:
  {
    request: 'Demande',
    boxRequestNotFound: 'Demande de boîte non trouvée ou ne peut pas être chargée.',
    assignedAt: 'Attribué le',
    noLogsAvailable: 'Aucun journal disponible',
    statusChangedTo: 'statut changé en',
    by: 'par',
  },
  table: {
    found: '{total} {name} trouvé(s)',
    perPage: '{name} par page :',
    noData: 'Aucune donnée disponible',
    filter: 'Filtrer par {name} :',
    listView: 'Vue Liste',
    kanBanView: 'Vue Kanban',
    toggleFilters: 'Basculer les filtres',
  },
  tableHeaders: {
    name: {
      title: 'Nom',
      first: 'Prénom',
      middle: 'Deuxième prénom',
      last: 'Nom de famille',
    },
    age: {
      title: 'Âge',
    },
    email: {
      title: 'Messagerie électronique'
    },
    phone: {
      title: 'Téléphone'
    },
    created_at: {
      title: 'Créé le',
    },
    price: {
      title: 'Prix',
    },
    code: {
      title: 'Code',
    },
    percentage: {
      title: 'Pourcentage',
    },
    status: {
      title: 'Statut',
    },
    adressChecked: {
      title: 'Adresse Vérifiée',
    },
    city: {
      title: 'Ville',
    },
    number: {
      title: 'Nombre',
    },
    userID: {
      title: 'User ID',
    },
    createdAt: {
      title: 'Créé Le',
    },
    client: {
      title: 'Client',
    },
    type: {
      title: 'Type',
    },
    stylist: {
      title: 'Styliste',
    },
    note: {
      title: 'Note',
    },
    boxNumber: {
      title: 'Box #',
    },
    channel: {
      title: 'Canal',
    },
    assignedAt: {
      title: 'Assigné le',
    },
    lastStatusUpdate: {
      title: 'Dernière mise à jour de statut',
    },
    lastUpdate: {
      title: 'Dernière mise à jour',
    },
    orderNumber: {
      title: 'Commande #',
    },
    quantity: {
      title: 'Qté', // Abbreviation for "Quantité"
    },
    quantitySold: {
      title: 'Qté Vendue',
    },
    netSales: {
      title: 'Ventes Nettes',
    },
    finalized: {
      title: 'Finalisé',
    },
    dispatched: {
      title: 'Expédié',
    },
    finalReturn: {
      title: 'Retour Final',
    },
    returned: {
      title: 'Retourné',
    },
    picked: {
      title: 'Prélevé'
    },
    barcode: { title: 'Code-barres' },
    offeredOn: { title: 'Proposé le' },
    deliveryDate: { title: 'Date de livraison' },
    labels: { title: 'Étiquettes' },
    understanding: { title: 'Compréhension' },
  },
  navigation: {
    users: 'Utilisateurs',
  },
  profile: {
    referral_code: 'Code de parrainage',
    title: 'Profil | Profils',
    setting: 'Paramètre | Paramètres',
    mine: 'Mon profil',
    standard: 'Informations standard',
    contact: {
      information: 'Informations de contact',
      person: 'Personne à contacter',
      number: 'Numéro de contact',
    },
    dob: 'Date de naissance',
    name: 'Nom',
    firstName: 'Prénom',
    middleName: 'Deuxième prénom',
    lastName: 'Nom de famille',
    email: 'Messagerie électronique',
    phone: 'Numéro de téléphone',
    website: 'Site web',
    country: 'Pays',
    password: {
      title: 'Nouveau mot de passe',
      forgot: 'Mot de passe oublié ?',
      current: 'Mot de passe actuel',
      confirm: 'Confirmer le mot de passe',
      change: 'Changer le mot de passe',
      save: 'Enregistrer le mot de passe',
      saved: 'Mot de passe enregistré',
    },
    group: 'Groupe',
    login: 'Se connecter en tant que',
    address: 'Adresse',
    street: 'Rue',
    housenumber: 'Numéro de maison',
    addition: 'Complément',
    postcode: 'Code postal',
    city: 'Ville',
    budgetHours: 'Heures budgétées',
    budgetMoney: 'Budget monétaire',
    code: 'Code',
    color: 'Couleur',
    invoiceName: 'Nom de la facture',
    calculationModel: 'Modèle de calcul',
    responsibleEmployee: 'Employé responsable',
  },
  avatar: {
    title: 'Photo de profil',
    change: 'Changer la photo',
  },
  general: {
    back: 'Retour',
    search: 'Recherche | Rechercher',
    cancel: 'Annuler',
    yes: 'Oui',
    no: 'Non',
    active: 'Actif',
    inactive: 'Inactif',
    startsAt: 'Commence à',
    endsAt: 'Se termine à',
  },
  time: {
    year: 'an | ans',
    month: 'mois',
    week: 'semaine | semaines',
    day: 'jour | jours',
    hour: 'heure | heures',
    minute: 'minute | minutes',
  },
  inbox: {
    title: '',
    menu: {
      inbox: 'Boîte de réception',
      starred: 'Favoris',
      sent: 'Envoyé',
      draft: 'Brouillon',
      create: 'Nouvel e-mail',
      folders: 'Dossiers',
    },
    actions: {
      delete: 'Supprimer',
      reply: 'Répondre',
      archive: 'Archiver',
      sent: 'Envoyé'
    },
    contact: 'Contact | Contacts'
  },
  form: {
    formFields: {
      avatar: 'Avatar',
      supplierName: 'Nom du fournisseur',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      middleName: 'Deuxième prénom',
      name: 'Nom',
      invoiceName: 'Nom de la facture',
      website: 'Site web',
      phone: 'Téléphone',
      username: "Nom d'utilisateur",
      email: 'Messagerie électronique',
      password: 'Mot de passe',
      category: 'Catégorie',
      confirmPassword: 'Confirmer le mot de passe',
      code: 'Code',
      percentage: 'Pourcentage',
      color: 'Couleur du projet',
      token: 'Jeton MFA',
      value: 'Valeur',
      country: {
        title: 'Pays',
        nl: 'Pays-Bas',
        en: 'Angleterre',
        de: 'Allemagne',
      },
    },
    optional: 'Optionnel',
    fieldsRequiredText: 'Tous les champs sont obligatoires',
  },
  languages: {
    title: 'Langue',
    nl: 'Néerlandais',
    en: 'Anglais',
    de: 'Allemand'
  },
  createDialog: {
    header: {
      create: 'Créer',
      overview: 'Aperçu',
      finished: 'Terminé',
    },
    body: {
      title: {
        activate: 'Activer le/la {role}',
        create: 'Créer un nouveau {role}',
        finished: '{role} est créé(e)',
        information: 'Informations sur le/la {role}',
        address: "Adresse du débiteur",
        postAddress: 'Adresse postale',
        officeAddress: "Adresse de visite",
      },
      description: {
        confirm: 'Confirmez que toutes les informations pour le/la nouveau/nouvelle {role} sont correctes',
        finished: 'Voir le/la {role} créé(e) ci-dessous',
      },
      upload: 'Téléverser',
    },
    actions: {
      reset: 'Créer un autre {role}',
    },
  },
  dialogOptions: {
    item: {
      client: 'Client',
      subscriptionType: "Type d'abonnement",
    },
    confirmation: 'Confirmation',
    delete: 'Êtes-vous sûr de vouloir supprimer ce {item} ? | Êtes-vous sûr de vouloir supprimer ces {item} ?',
    deleteMany: 'Êtes-vous sûr de vouloir supprimer {item} ?',
    lessonT: 'Êtes-vous sûr de vouloir aller à ce {item} ?',
    save: '{item} est sauvegardé',
    update: 'Êtes-vous sûr de vouloir mettre à jour ce {item} ? | Êtes-vous sûr de vouloir mettre à jour ces {item} ?',
    existingOrderFound: 'Commande existante trouvée',
    existingOrderFoundForClient: 'Il y a déjà une commande pour ce client',
    showOrder: 'Afficher la commande',
    button: {
      delete: 'Supprimer',
      cancel: 'Annuler',
      ok: "D'accord",
    },
  },
  bugReport: {
    title: 'Bug',
    header: 'Signaler un bug',
    field: {
      title: 'Titre',
      description: 'Description',
      screenshot: 'Capture d’écran',
    },
    create: {
      title: 'Ajoutez un titre',
      description: 'Ajoutez une description.',
      descriptionExplanation: "Quand ce bug est-il survenu ? Quelles étapes et/ou actions avez-vous effectuées ? Sur quels boutons avez-vous cliqué ?",
      screenshot: 'Capture d’écran',
      submitBug: 'Signaler le bug',
      created: 'Votre rapport de bug a été créé.',
      downloadScreenshot: "Télécharger l'image",
      uploadScreenshot: "Téléversez l'image téléchargée depuis le lien",
    },
    alert: {
      noIdSet: "L'ID du tableau Monday ou l'ID du groupe n'a pas été défini, impossible de créer un pulse",
      warning: 'Attention',
    },
    reportContent: {
      description: 'Description',
      localStorage: 'Stockage local',
      stacktrace: 'Trace de la pile',
      message: 'Message',
      file: 'Fichier',
      line: 'Ligne',
      column: 'Colonne',
      error: 'Erreur',
    },
  },
  errors: {
    loading: {
      description: "Il y a eu un problème lors du chargement des informations requises.",
      suggestion: 'Veuillez réessayer plus tard.',
    },
    notFound: {
      description: "La page que vous recherchez n'a pas pu être trouvée.",
      suggestion: '404',
      url: "Veuillez vérifier l'URL pour d'éventuelles fautes de frappe",
      error: 'ERREUR 404.',
      back: "aller à l'accueil",
      oops: 'Oups :(',
      or: 'ou',
      contact: 'contactez-nous via',
    },
  },
  hours: {
    hour: 'heure | heures',
  },
  contact: 'Contact',
  contacts: 'Contacts',
  menu: {
    requests: 'Requêtes',
    orders: 'Ordres',
  },
  hamburgerMenu: {
    account: 'Mon Compte',
    settings: 'Paramètres',
  },
  filters: {
    filters: 'Filtres',
    statusFilter: {
      toBeContacted: 'À contacter',
      waitingForReply: 'En attente de réponse',
      noReply: 'Pas de réponse',
      orderInProgress: 'À styliser',
      completed: 'Terminé',
    },
    typeFilter: {
      swapBox: 'Boîte d\'échange',
      styledBox: 'Boîte stylée',
      studio: 'Studio',
      afterSales: 'Service après-vente',
      promotion: 'Promotion',
      supplierReturn: 'Retour fournisseur',
      swipeToShop: 'Swipe-to-shop',
      shopify: 'Shopify',
      stylingFee: 'Frais de stylisme',
      other: 'Autre',
    },
    orderStatusFilter: {
      active: 'Actif',
      inactive: 'Inactif',
      preview: 'Aperçu',
      finalized: 'Finalisé',
      checkout: 'Paiement',
      invoiced: 'Facturé',
      completed: 'Terminé',
      lost: 'Perdu',
      cancelled: 'Annulé',
      allocated: 'Attribué',
      partiallyAllocated: 'Partiellement attribué',
      picked: 'Prélevé',
      partiallyPicked: 'Partiellement prélevé',
      shipped: 'Expédié',
      partiallyShipped: 'Partiellement expédié',
      dispatched: 'Envoyé',
      partiallyDispatched: 'Partiellement envoyé',
    },
    finalReturnDate: 'Date de retour finale',
  },
  contactsPage: {
    cardview: {
      newOrder: 'Créer une nouvelle commande',
      editStatus: 'Modifier le statut',
      createNewOrder: 'Créer une nouvelle commande',
      finishOrder: 'Terminer la commande',
      fillAdress: 'Entrez les détails de l\'adresse et poursuivez la commande',
    },
    quizView: {
      styleQuiz: 'Quiz de style',
      quizCreatedAt: 'Quiz créé à :',
      style: 'Style',
      bodyType: 'Type de corps',
      preferences: 'Préférences',
      myFotos: 'Mes photos',
      box: 'Box',
      notes: 'Notes du styliste',
    },
    attachments: 'Pièces jointes',
    listView: {
      search: 'Rechercher',
      signUpDate: 'Date d’inscription',
    },
  },
  orders: {
    checkOrder: 'Voir la commande',
    orderDetail: {
      orderItems: 'Articles commandés',
      relatedSets: 'Ensembles associés',
      evaluation: 'Évaluation',
      attachments: 'Pièces jointes',
      labels: 'Étiquettes',
      updateOrder: 'Mettre à jour la commande',
      orderItemsBlock: {
        notAllocatedItems: 'Articles non alloués',
        itemName: 'Nom de l\'article',
        quantity: 'Quantité',
        price: 'Prix',
        tax: 'Taxe',
        total: 'Total',
        allocatedItems: 'Articles alloués',
        noItemsAreAllocated: 'Aucun article alloué',
        pickedItems: 'Articles sélectionnés',
        noItemsArePicked: 'Aucun article sélectionné',
        dispatchedItems: 'Articles expédiés',
        noItemsAreDispatched: 'Aucun article expédié',
        returnedItems: 'Articles retournés',
        noItemsAreReturned: 'Aucun article retourné',
        returnBatch: 'Lot de retour',
        keptItems: 'Articles conservés',
        discount: 'Remise',
        noItemsAreKept: 'Aucun article conservé',
        totalUnits: 'Unités totales',
        subTotal: 'Sous-total',
        referralDiscount: 'Remise de parrainage',
        includingVat: 'TVA incluse (21%)',
        returnDate: 'Date de retour',
        orderDiscount: 'Remise sur la commande',
      },
      relatedSetsBlock: {
        newSet: 'Nouveau kit',
        size: 'Taille:',
        brand: 'Marque:',
        editPersonalNote: 'Modifier la note personnelle',
        createdAt: 'Créé à',
        cancel: 'Annuler',
      },
      evaluationBlock: {
        orderEvaluation: 'Évaluation de la commande',
        stylistUnderstanding: 'Dans quelle mesure pensez-vous que votre styliste a bien compris votre style ?',
        anotherBox: 'Pensez-vous que vous aimeriez recevoir une autre boîte ?',
        satisfiedWithBox: 'Dans quelle mesure êtes-vous satisfait(e) de la box ?',
        willYouAdvise: 'Dans quelle mesure est-il probable que vous recommandiez Maison365 à d’autres ?',
        isTheChoiceGood: 'Dans quelle mesure êtes-vous d’accord avec l’affirmation que Maison365 permet d’obtenir facilement de jolis vêtements ?',
      },
      orderedItemsEvaluation: {
        orderItemsEvaluation: 'Évaluation des articles de commande',
        product: 'Produit',
        overall: 'Global',
        fit: 'Coupe',
        style: 'Style',
        other: 'Autre',
        good: 'Bon',
        size: 'Taille:',
        tooLarge: 'Trop grand',
        tooSmall: 'Trop petit',
        keep: 'Garder',
        return: 'Retour',
        exchange: 'Échanger',
        tooWide: 'Trop large',
        tooTight: 'Trop serré',
        tooLong: 'Trop long',
        tooShort: 'Trop court',
        tooSimple: 'Trop simple',
        tooBusy: 'Trop chargé',
        tooSolid: 'Trop robuste',
        tooYoung: 'Trop jeune',
        colorNotNice: 'Couleur pas jolie',
        printNotNice: 'Impression pas jolie',
        materialFinishingNotNice: 'Matériel/Finition pas agréable',
        tooExpensive: 'Trop cher',
        alreadyHaveSomethingSimilar: 'J’ai déjà quelque chose de similaire',
        generalEvaluation: "Évaluation générale",
        sizeEvaluation: "Évaluation de la taille",
        fitEvaluation: "Évaluation de l'ajustement",
        styleEvaluation: "Évaluation du style",
        otherEvaluation: "Évaluation diverse",
      },
      attachmentsBlock: {
        orderAttachments: 'Pièces jointes de commande',
        noOrderAttachments: 'Il n’y a pas de pièces jointes de commande',
        seeOrderAttachments: 'Voir les pièces jointes de commande',
      },
      listView: {
        nanOrdersFound: 'Commandes NaN trouvées',
        search: 'Rechercher',
        ordersPerPage: 'Commandes par page',
      },
      webshop: {
        filters: {
          search: 'Rechercher',
          colors: 'Couleurs',
          brands: 'Marques',
          suppliers: 'Fournisseurs',
          categories: 'Catégories',
          tags: 'Étiquettes',
          materials: 'Matériaux',
          price: 'Prix',
          sizes: 'Tailles',
          season: 'Saison',
          pantsLength: 'Pantalon : Longueur',
          details: 'Détails',
          sustainable: 'Viable',
          pantsFit: 'Pantalon : Coupe',
          jacketsFit: 'Vestes : Coupe',
          dressesFit: 'Robes : Coupe',
          topsFit: 'Hauts : Coupe',
          collar: 'Col',
          jacketsLength: 'Vestes : Longueur',
          dressesLength: 'Robes : Longueur',
          topsLength: 'Dessus : Longueur',
          sizeGuide: 'Guide des tailles',
          material: 'Matériel',
          sleeveSize: 'Taille des manches',
          pattern: 'Modèle',
          closure: 'Fermeture',
          style: 'Style',
          pantsType: 'Pantalon : Type',
          jacketsType: 'Vestes : Type',
          skirtType: 'Jupe : Type',
          rerun: 'Rediffusion',
          dummyUPC: 'UPC factice',
          removeAllFilters: 'Supprimer tous les filtres',
        },
        styleView: {
          availableSizes: 'Tailles disponibles',
        },
        sideBar: {
          height: 'Hauteur',
          cup: 'Coupe',
          jeans: 'Jeans',
          tops: 'Hauts',
          topSize: 'Taille supérieure',
          bottomSize: 'Taille du bas',
          customer: 'Client',
          style: 'Style',
          brands: 'Marques',
          keywords: 'Mots-clés',
          dresscodeAtWork: 'Code vestimentaire au travail',
          monthlyBudget: 'Budget mensuel',
          colors: 'Couleurs',
          shoppingCart: 'Caddie',
          size: 'Taille',
          total: 'Total:',
          createSets: 'Créer des ensembles',
          client: 'Client',
          items: 'Articles',
          colorDontUse: 'Quelles couleurs ne portez-vous pas',
          fabricDontUse: 'Quels tissus ne portez-vous pas',
          patternDontUse: 'Quels motifs ne portez-vous pas',
          camouflage: 'Camouflage',
          motivation: 'Motivation',
          thisBox: 'Cette box',
          lookingFor: 'Principalement à la recherche de',
          specificItems: 'Articles spécifiques que le client souhaite recevoir',
          other: 'Autre',
          shapePreferenceTops: 'Préférence de coupe pour les hauts',
          budget: 'Budget',
          trousers: 'Pantalons',
          fittingTrousers: 'Comment les pantalons vous vont-ils généralement à la taille ?',
          skirts: 'Jupes',
          dresses: 'Robes',
          lengthSkirt: 'Quelle longueur de jupe vous convient ?',
          accessories: 'Accessoires',
          describeAccessories: 'Comment décririez-vous votre style pour les accessoires et les bijoux ?',
          preferenceColor: 'Couleur de bijoux préférée',
          earsPierced: 'Avez-vous des piercings aux oreilles ?',
          noProductsCart: 'Il n\'y a pas de produits dans le panier',
        },

        productView: {
          backToTheShop: 'Retour à la boutique',
          inStock: 'En stock',
          productDetailsPhotosOkNotOk: 'Détails du produit & photos OK/PAS OK pour couleur Bleu foncé, taille 36 ?',
          addToCart: 'Ajouter au panier',
          color: 'Couleur',
          productAttributes: 'Attributs du produit',
          supplierCode: 'Code fournisseur',
          location: 'Emplacement',
          selectOtherSize: 'Sélectionnez une autre taille',
          outOfStock: 'Rupture de stock',
          productAlreadyInCart: 'Ce produit est déjà dans votre panier',
          availableInShopify: 'Disponible sur Shopify',
          reserved: 'Réservé',
          noMaterials: 'Aucun matériau pour ce produit',
          noTags: 'Aucun tag pour ce produit',
        },
        sets: {
          addAllToOtherItems: "Ajouter tout à 'Autres éléments'",
          otherItems: 'Autres articles',
          totalPrice: 'Prix total :',
          totalProducts: 'Total des produits :',
          createPersonalNote: 'Créer une note personnelle',
          newSet: 'Nouveau kit',
          back: 'Précédent',
          tip: 'ASTUCE :',
          packInThisSet: 'Emballer dans cet ensemble',
          setExplanation: 'Explication de l’ensemble',
        },
        personalNote: {
          personalNote: 'Note personnelle',
          updatePersonalNote: 'Mettre à jour la note personnelle',
          totalPrice: 'Prix total :',
          totalProducts: 'Total des produits :',
          finalizeThisOrder: 'Finaliser cette commande',
          introText: 'Texte d’introduction',
          noExplanationForSet: 'Aucune explication n’a été donnée pour cet ensemble',
          outroText: 'Texte de l’outro',
          back: 'Précédent',
          originalText: 'Texte original',
          selectLanguageNote: 'Sélectionnez la langue de la note personnelle pour votre client',
          inOriginalLanguage: 'Afficher dans la langue originale',
          translateToOtherLanguage: 'Traduire dans une autre langue',
          selectLanguage: 'Sélectionner la langue',
          translatedText: 'Texte traduit',
          translate: 'Traduire',
          orderSucceded: 'Commande réussie',
          orderDefinitive: 'La commande a été finalisée.',
          orderOverview: 'Aller à l\'aperçu de la commande',
          editPersonalNotes: 'Modifier les notes personnelles',
          update: 'Mettre à jour',
          cancel: 'Annuler',
          sureYouWantToUpdate: 'Êtes-vous sûr de vouloir mettre à jour la note personnelle ?',
        },
        maia: {
          name: 'Maia',
          subtitle: 'Styling Support',
          openChat: 'Demandez à Maia',
          you: 'Vous',
          placeholder: 'Tapez un message..',
          viewProduct: 'Voir le produit',
          greeting: 'Bonjour ! Je vous aide volontiers à composer cette box. Par quoi voulez-vous commencer ?',
          greetingNamed: 'Bonjour ! Je vous aide volontiers avec la box de {customer}. Par quoi voulez-vous commencer ?',
          error: 'Désolée, je n\'ai pas pu obtenir de réponse. Veuillez réessayer.',
          suggestions: {
            jeans: 'Quels jeans conviennent à cette cliente ?',
            eyeCatcher: 'Proposez une pièce forte à moins de 150 €',
            missing: 'Qu\'est-ce qui manque encore dans cette box ?',
          },
          // Le contrôle croisé avec le profil de la cliente, par recommandation.
          // Les clés viennent du backend (MaiaRecommendationCheck) pour que le
          // texte soit dans la langue de la styliste et non dans celle du modèle.
          checks: {
            notChecked: 'Non vérifiable',
            over: '{amount} au-dessus du budget',
            breaks: '{rule} ne convient pas',
            rules: {
              size: 'taille',
              colour: 'couleur',
              dress: 'pas de robe',
              budget: 'budget',
              wishlist: 'sur sa liste de souhaits',
              fabric: 'matière',
              print: 'imprimé',
              camouflage: 'camoufler',
              profile: 'pas de profil',
            },
          },
        },
      },
    },
  },
  mfaSetup: {
    mfaNotYetSetup: 'MFA n\'est pas encore configuré',
    mfa: "Configurer MFA",
    mfaSetup: "Configurer le jeton MFA",
    step1: "Prenez votre téléphone.",
    step1_ios: 'Si vous avez un <b>iPhone</b>, ouvrez l’App Store et recherchez <b>"Step Two"</b>.',
    step1_android: 'Si vous avez un <b>téléphone Android</b>, ouvrez le Play Store et recherchez <b>"Google Authenticator"</b>.',
    step1_download: "Téléchargez ensuite cette application sur votre téléphone.",
    step2: "Ouvrez l'application que vous venez de télécharger et ajoutez le jeton",
    step2_steptwo: '<b>Step Two</b> : Appuyez sur l’icône + et scannez le QR code ci-dessous :',
    step2_google: '<b>Google Authenticator</b> : Démarrez la configuration et appuyez sur “Scanner le code-barres”.',
    step2_scan: "Scannez maintenant le QR code ci-dessous.",
    step3: "Après avoir scanné le QR code, vous verrez un code à 6 chiffres avec un minuteur. Celui-ci expire toutes les 30 secondes.",
    step4: 'Entrez le code de votre application dans <b>"Token 1"</b>.',
    step5: "Attendez que le code expire, puis entrez le nouveau code dans <b>'Token 2'</b>.",
    step6: 'Terminez la configuration en cliquant sur <b>"Enregistrer le jeton"</b>.',
    token1_label: "Token 1",
    token2_label: "Token 2",
    save_token: "Enregistrer le jeton",
    cancel: "Annuler"
  },
};
